import { useCurrentCommunityMember } from "@circle-react/contexts/punditUserContext";
import { Button } from "@circleco/compass/components/Button";
import { Icon } from "@circleco/compass/components/Icon";
import { Typography } from "@circleco/compass/components/Typography";
import { useNavigate } from "@tanstack/react-router";

import { t } from "@/i18n-js/instance";
import { memberProfileModalPaths } from "@/react/helpers/urlHelpers/memberProfileModalPaths";

export const Banner = () => {
  const currentCommunityMember = useCurrentCommunityMember();
  const navigate = useNavigate();

  const isMessagingEnabled =
    currentCommunityMember?.messaging_enabled_by_member &&
    currentCommunityMember?.messaging_enabled_by_admin;

  if (isMessagingEnabled) {
    return null;
  }

  const openEditProfile = () => {
    void navigate({ to: memberProfileModalPaths.privacy });
  };

  const isAdmin = currentCommunityMember?.is_admin;

  return (
    <div className="flex min-h-[81px] w-full items-center justify-between rounded-t-md bg-tertiary px-4 py-3">
      <div className="mr-3 flex min-w-0 flex-1 items-center gap-3">
        <div className="shrink-0">
          <Icon name="circle-info" size="md" />
        </div>
        <Typography variant="body-sm" className="break-words">
          {isAdmin
            ? t("messaging.banner.admin_messaging_disabled")
            : t("messaging.banner.member_messaging_disabled")}
        </Typography>
      </div>
      <Button
        variant="outline"
        size="sm"
        onClick={openEditProfile}
        className="shrink-0"
      >
        {t("messaging.banner.manage")}
      </Button>
    </div>
  );
};
